export default __webpack_public_path__ + "static/media/daon-logo_0.59b293bb.jpg";